import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { format } from 'date-fns'
import { ProcessedEvent } from '../../types'
import { useSchedulerPropsContext } from '../../context/schedulerContext'
import styles from './EventItem.module.css'

export interface EventItemContentProps {
  event: ProcessedEvent
  showdate?: boolean
  isBackgroundEvent?: boolean
}

export const EventItemContent: FC<EventItemContentProps> = ({
  event,
  showdate,
}) => {
  const { locale } = useSchedulerPropsContext()
  return (
    <div className={styles.EventItem__content}>
      <span className={styles.EventItem__contentTitle}>
        {event.summary}
      </span>
      {showdate && (
        <Typography style={{ fontSize: 11 }} noWrap>
          {format(event.start, 'hh:mm a', {
            locale: locale,
          })}
        </Typography>
      )}
    </div>
  )
}
